// export default () => ({
// })

export default () => ({
    outputs: [],
    outputsPaginatedData: null,
    output: null,
    isLoading: false
})